import { Thead, Tr, Th } from '@chakra-ui/react';
import useFormColumns from './useFormColumns';

const TableHeader = () => {
  const cols = useFormColumns();
  return (
    <Thead>
      <Tr>
        <Th>Date</Th>
        {cols.map((col, id) => <Th key={id}>{col.label}</Th>)}
      </Tr>
    </Thead>
  );
};

export default TableHeader;
